import React from 'react';
import './Sections.scss';

function Section2() {
  return (
    <section className="sections sections-marginBox">
      <h2 className="sections-title">Planting a hedge against inflation</h2>
      <p className="sections-copy">
        These days, inflation is on everyone’s mind. With consumer prices rising at the fastest pace
        in decades, homeowners can take comfort knowing that real estate values have historically
        kept pace with inflation.
      </p>
      <p className="sections-copy">
        “In the 1970s, when inflation was running around 10%, home prices were rising at
        approximately the same rate,” says{' '}
        <a
          className="hyperLink"
          href="https://www.nar.realtor/lawrence-yun"
          target="_blank"
          rel="noreferrer"
        >
          Dr. Lawrence Yun, Chief Economist at the National Association of REALTORS® (NAR)
        </a>
        . “Renters actually have a harder time in inflationary periods, because rents tend to rise
        along with inflation, whereas mortgage payments stay the same for homeowners with fixed-rate
        mortgages.”
      </p>
      <p className="sections-copy">
        In a real sense, a fixed-rate mortgage payment actually becomes ‘cheaper’ over time. The
        dollar amount of the monthly payment holds steady, but inflation tends to eat away at the
        value of those dollars as the years go by.
      </p>
    </section>
  );
}

export default Section2;
